import { utilsQuery } from "@app/common";

const define = utilsQuery.defineQueryKeyCreator("room-extras");

export const QueryKeys = {
    RoomRateExtras: define("room-rate-extras"),
    RoomRateTaxes: define("room-rate-taxes"),
} as const;
